import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as string | null;

const slice = createSlice({
  name: '$notes',
  initialState,
  reducers: {
    setNotes(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, (_state, _action) => {
      return initialState;
    });
  },
});

export const { setNotes } = slice.actions;
export default slice.reducer;
